import { ApiGuide } from '../api';

export interface AppGuide {
    guideId: number;
    userId: string;
    transportationId: number;
    transportationName: string;
    isActive: boolean;
    companyUniqueId: string;
    guideFullName: string;
    guideFullNameText: string;
    guideText: string;
    guideText30: string;
    capacity: number;
}

export function fromApiGuides(guides: ApiGuide[]): AppGuide[] {
    return guides.map((guide) => fromApiGuide(guide));
}

export function fromApiGuide(guide: ApiGuide): AppGuide {
    return {
        guideId: guide.GuideId,
        userId: guide.UserId,
        transportationId: guide.TransportationId,
        transportationName: guide.TransportationName,
        isActive: guide.IsActive,
        companyUniqueId: guide.CompanyUniqueID,
        guideFullName: guide.GuideFullName,
        guideFullNameText: guide.GuideFullNameText,
        guideText: guide.GuideText,
        guideText30: guide.GuideText30,
        capacity: guide.Capacity,
    };
}
